/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.0",
  "gitBuildTime": "2026-03-17T20:57:41.829Z",
  "gitBuildVersion": "2.9.0",
  "gitCommitId": "40aab43",
  "gitCommitIdFull": "40aab43f4990af6e064c689b7d865f9c38e98a49",
  "gitCommitTime": "2026-03-17T20:56:11.000Z",
  "version": "2.9.0-2026-03-17T20:56:11.000Z-(40aab43)"
};
